import React, { useState, useEffect } from "react";
import { Form, Button } from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useAuth } from "../../../hook/userAuth";
import { ToastContainer, toast } from "react-toastify";
import { BASE_API } from "../../../ruta-server/BaseApi";

export function UpdateProfile(props) {
  const { onClose, onRefetch, user } = props;
  const [usuarios, setUsuarios] = useState(null);
  const [refetch] = useState(false);
  const { auth } = useAuth();

  //SE REFRESQUE LA PAGINA
  async function getUsersApi() {
    try {
      const response = await axios.get(`${BASE_API}/api/users`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });
      const result = response.data;
      setUsuarios(result);
      return result;
    } catch (error) {
      window.location.reload();
      window.location.href = "/Login";
      throw error;
    }
  }

  useEffect(() => {
    getUsersApi();
    // eslint-disable-next-line
  }, [refetch]);

  const updatePersonalDoc = async (data) => {
    try {
      await updatePeronalDocApi(data);
    } catch (error) {
      throw error;
    }
  };

  async function updatePeronalDocApi(data) {
    try {
      const url = `${BASE_API}/api/users/${auth.me.id}/`;
      const headers = {
        Authorization: `Bearer ${auth.token}`,
        "Content-Type": "application/json",
      };

      const response = await axios.patch(url, data, { headers });
      window.location.reload();
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 400) {
        const existingUserByCurp = usuarios.find(
          (usuarios) => usuarios.curp === data.curp
        );
        if (existingUserByCurp) {
          toast.error("Ya existe un usuario con esa CURP");
        }
      }
      throw error;
    }
  }

  const formatName = (value) => {
    const parts = value.split(" ");
    const formattedParts = parts.map((part) => {
      return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
    });
    return formattedParts.join(" ");
  };

  const formik = useFormik({
    initialValues: initialValues(user),
    validationSchema: Yup.object(updateSquema()),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        formValue.first_name = formatName(formValue.first_name);
        formValue.last_name = formatName(formValue.last_name);
        formValue.curp = formValue.curp.toUpperCase();
        if (user) await updatePersonalDoc(formValue);
        onRefetch();
        onClose();
      } catch (error) {
        console.error(error);
      }
    },
  });

  return (
    <>
      <Form className="add-edit-user-form" onSubmit={formik.handleSubmit}>
        <label>
          Nombre <span className="astedisco">*</span>
        </label>
        <Form.Input
          name="first_name"
          placeholder="Nombre(s)"
          value={formik.values.first_name}
          onChange={formik.handleChange}
          error={formik.errors.first_name}
        />
        <label>
          Apellido Paterno <span className="astedisco">*</span>
        </label>
        <Form.Input
          name="last_name"
          placeholder="Apellido paterno"
          value={formik.values.last_name}
          onChange={formik.handleChange}
          error={formik.errors.last_name}
        />
        <label>
          Apellido Materno <span className="astedisco">*</span>
        </label>
        <Form.Input
          name="apellido_materno"
          placeholder="Apellido materno"
          value={formik.values.apellido_materno}
          onChange={formik.handleChange}
          error={formik.errors.apellido_materno}
        />
        <label>
          Nombre de usuario <span className="astedisco">*</span>
        </label>
        <Form.Input
          name="username"
          placeholder="nombre de usuario"
          value={formik.values.username}
          onChange={formik.handleChange}
          error={formik.errors.username}
        />
        <label>Apellidos</label>
        <Form.Input
          name="last_name"
          placeholder="Apellidos"
          value={formik.values.last_name}
          onChange={formik.handleChange}
          error={formik.errors.first_name}
        />
        {user.es_docente ||
          (user.is_superuser && (
            <>
              <label>Nombre</label>
              <Form.Input
                name="first_name"
                placeholder="Nombre(s)"
                value={formik.values.first_name}
                onChange={formik.handleChange}
                error={formik.errors.first_name}
              />
            </>
          ))}

        <label>CURP</label>
        <Form.Input
          name="curp"
          placeholder="CURP"
          value={formik.values.curp}
          onChange={(e, { name, value }) => {
            formik.handleChange(e);
            formik.setFieldValue(name, value.toUpperCase());
          }}
          error={formik.errors.curp}
        />
        <label>Correo electrónico</label>
        <Form.Input
          name="email"
          placeholder="Correo electrónico"
          value={formik.values.email}
          onChange={formik.handleChange}
          error={formik.errors.email}
        />

        <label>Número de teléfono</label>
        <Form.Input
          name="telefono"
          placeholder="Número de teléfono"
          value={formik.values.telefono}
          onChange={formik.handleChange}
          error={formik.errors.telefono}
        />

        {user.es_docente ||
          (user.is_superuser && (
            <>
              <label>Grado académico</label>
              <Form.Input
                name="grado_estudio"
                placeholder="Grado académico"
                value={formik.values.grado_estudio}
                onChange={formik.handleChange}
                error={formik.errors.grado_estudio}
              />
            </>
          ))}
        <Button
          type="submit"
          content={"Actualizar"}
          style={{ backgroundColor: "#008e86", color: "white" }}
          fluid
        />
      </Form>
      <ToastContainer />
    </>
  );
}

function initialValues(datosUsuario) {
  return {
    username: datosUsuario?.username || "",
    telefono: datosUsuario?.telefono || "",
    email: datosUsuario?.email || "",
    first_name: datosUsuario?.first_name || "",
    last_name: datosUsuario?.last_name || "",
    apellido_materno: datosUsuario?.apellido_materno || "",
    password: "",
    curp: datosUsuario?.curp || "",
    categoria: datosUsuario?.categoria || "",
    grado_estudio: datosUsuario?.grado_estudio || "",
  };
}

function updateSquema() {
  return {
    username: Yup.string()
      .required(true)
      .test(
        "no-spaces",
        "No se permiten espacios en el nombre de usuario",
        (value) => !/\s/.test(value)
      )
      .trim(),
    email: Yup.string().email(true).required(true),
    telefono: Yup.string()
      .required(true)
      .matches(
        /^\d{10}$/,
        "El número de teléfono debe tener 10 dígitos y solo debe contener números"
      ),
    curp: Yup.string()
      .required(true)
      .matches(
        /^[A-Z]{4}\d{6}[HM]{1}[A-Z]{5}[A-Z\d]{1}\d{1}$/,
        "El formato de la CURP no es válido"
      )
      .max(18, "La CURP no debe tener más de 18 caracteres"),
    //categoria: Yup.string().required(true),
    //grado_estudio: Yup.string().required(true),
    first_name: Yup.string().required(true),
    last_name: Yup.string().required(true),
  };
}
